import React, { useEffect, useState } from 'react';
import { BiChevronDown } from 'react-icons/bi';
import { Dropdown, DropdownItem, DropdownList } from '@cokitchen/cokitchen-components';
import { DineInTableType } from '../../helpers/types';
import dataService from '../../services/data.service';
import { STORAGE_KEYS } from '../../helpers/constants';

const TableFiter = ({
  dineInTable,
  setDineInTable
}: {
  dineInTable: DineInTableType | null;
  setDineInTable: (value: DineInTableType | null) => void;
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [tables, setTables] = useState<DineInTableType[]>([]);

  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  const changeTable = (table: DineInTableType | null) => {
    setDineInTable(table);
    toggleDropdown();
  };

  const fectchCokitchenTables = async () => {
    try {
      const res = await dataService.getAuthData(
        'dine-in-tables',
        { cokitchen_id: cokitchenId },
        { useBrand: true }
      );
      setTables(res.data.data.data as DineInTableType[]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fectchCokitchenTables();
  }, []);
  return (
    <Dropdown
      visible={showDropdown}
      onClickOutside={() => setShowDropdown(false)}
      content={
        <div className='flex items-center gap-2 capitalize' role='button' onClick={toggleDropdown}>
          <div>
            {dineInTable !== null && !Number.isNaN(dineInTable.number)
              ? `Table ${dineInTable.number}`
              : 'Table Number'}
          </div>
          <BiChevronDown
            size={20}
            className='rounded-full text-gray-5 cursor-pointer hover:bg-gray-1 transition-all'
          />
        </div>
      }>
      <DropdownList>
        <DropdownItem
          className='text-sm font-medium text-[#2e3031]'
          onClick={() => changeTable(null)}>
          All
        </DropdownItem>
        {tables.map((table) => (
          <DropdownItem
            key={table.id}
            className='text-sm font-medium text-[#2e3031]'
            onClick={() => changeTable(table)}>
            Table {table.number}
          </DropdownItem>
        ))}
      </DropdownList>
    </Dropdown>
  );
};

export default TableFiter;
